import { useQuery } from 'react-query';

//consts
import { QUERY_KEYS } from 'consts/queryKeys';
import { useCommonDropdownValues, useCurrenciesQuery } from 'modules/_common';
import { getContracts } from 'modules/accommodations/features/rentals/CreateRental/_common/api';
import { TContract } from 'modules/accommodations/features/rentals/CreateRental/_common/models';
//services
import { getReservationType } from 'modules/accommodations/features/reservations/api';

interface IProps {
  reservationId: string;
  reservationType?: string;
  propertyCode?: string;
}

export const useQueryReservationEdit = ({
  reservationId,
  reservationType = 'REZ',
  propertyCode,
}: IProps) => {
  const {
    error: isErrorReservation,
    data: reservation,
    isLoading: isLoadingReservation,
  } = useQuery([QUERY_KEYS.UNITS_RESERVATION_TYPE, reservationId, reservationType], () =>
    getReservationType(reservationId, reservationType),
  );

  const { dropdownValues, isLoadingCommonDropdownValues, isErrorCommonDropdownValues } =
    useCommonDropdownValues(['Languages', 'Partners']);

  const { partners, reservationLanguage } = dropdownValues;

  const {
    data: currencies,
    isLoading: isLoadingCurrencies,
    isError: isErrorCurrencies,
  } = useCurrenciesQuery();

  const {
    error: errAllContracts,
    data: allContractsOptions,
    isLoading: isLoadingAllContracts,
  } = useQuery(
    [QUERY_KEYS.RENTALS_PROPERTY_CONTRACTS, propertyCode],
    () => getContracts(propertyCode ?? ''),
    { enabled: !!propertyCode },
  );

  const activeContractOptions =
    allContractsOptions?.filter((item: TContract) => item.isActive === true) ?? [];

  return {
    isError: isErrorReservation || isErrorCommonDropdownValues || isErrorCurrencies,
    data: {
      reservation,
      currencies,
      partners,
      reservationLanguage,
      activeContractOptions,
    },
    isLoading: isLoadingReservation || isLoadingCommonDropdownValues || isLoadingCurrencies,
    isLoadingContracts: isLoadingAllContracts,
    isErrorContracts: errAllContracts,

    renterOptions: activeContractOptions.map((item: TContract) => ({
      label: item.partnerName,
      value: item.partnerId,
    })),
  };
};
